export const HELP_PAGE_URL = 'https://classovo.pl/pomoc/';
export const API_HOST = 'https://app.classovo.pl';
export const PRICING_PAGE_URL = 'https://classovo.pl/cennik';
export const APP_URL = 'https://app.classovo.pl';
export const API_DOCUMENTATION_URL = 'https://app.classovo.pl/api-documentation';
